var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showNavbar)?_c('div',[_c('k-app-bar',_vm._b({attrs:{"app":"","color":"white","clipped-left":_vm.clippedLeft}},'k-app-bar',_vm.$attrs,false),[_vm._t("buttons-left"),_c('div',{class:{
        'title-header': !_vm.isMobile,
        'title-header-mobile': _vm.isMobile && _vm.center
      }},[_c('v-layout',{staticClass:"align-center"},[_vm._t("title")],2)],1),_c('v-spacer'),_vm._t("buttons-right")],2)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }